module.exports = __webpack_public_path__ + "assets/images/project/map-logo-desktop.jpg?v=173e802a";